const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

const LISTAR_SUBTIPOS_HIERARQUIAS = (state, payload) => {
  state.subTiposHierarquias = payload
}

const LISTAR_MACROTIPOS_HIERARQUIAS = (state, payload) => {
  state.macroTiposHierarquias = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_TIPO_TAREFA_SELECIONADA = (state,  payload) => {
  state.selecionado = payload
}

export {
    LISTAR_DADOS,
    LISTAR_SUBTIPOS_HIERARQUIAS,
    CARREGANDO,
    LISTAR_MACROTIPOS_HIERARQUIAS,
    INSERIR_TIPO_TAREFA_SELECIONADA
}